<template>
  <div style="height:100%;">
    <van-nav-bar
      title="抽奖活动"
      left-text=""
      left-arrow
      @click-left="onClickLeft()">
    </van-nav-bar>
    <van-notice-bar left-icon="volume-o" :scrollable="false" style="height:25px;">
      <van-swipe vertical class="notice-swipe" :autoplay="1500" :show-indicators="false">
        <van-swipe-item v-for="(item,index) in luckyerList" :key="index">{{item}}</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <div class="dial">
      <div style="text-align:right;margin-top:1%;margin-right:5px;">
        <van-tag mark type="danger" size="large" @click="toDrawLog()">抽奖记录</van-tag>
      </div>
      <div style="text-align:right;margin-top:1%;margin-right:5px;">
        <van-tag mark type="danger" size="large" @click="toDrawDetail()">活动详情</van-tag>
      </div>

      <div id="dial1" style="height:100%;width:100%;" v-show="isDrawVisible1">
        <div style="text-align:center;">
          <img src="../../assets/draw2026/title_bg.png" style="width:80%;margin-top:1%;" />
        </div>
        <div style="margin-top:1%;text-align:center;">
          <van-tag type="danger" size="large" style="font-size:15px;width:80%;">
            <div v-if="drawedNum<3">您本阶段单量为{{processNum}}，您还有 {{remaindrawChance}} 次抽奖机会，第三次抽奖转盘升级，最高可中1888！</div>
            <div v-else-if="drawedNum>=3&&drawedNum<5">您本阶段单量为{{processNum}}，您还有 {{remaindrawChance}} 次抽奖机会，第五次抽奖转盘升级，最高可中4888！</div>
            <div v-else>
              您本阶段单量为 {{processNum}}，您还有 {{remaindrawChance}} 次抽奖机会
            </div>
          </van-tag>
        </div>
        <!-- 转盘包裹1 -->
        <div class="rotate">
          <!-- 转盘图片 -->
          <img class="dish" src="../../assets/draw2026/dial1.png" :style="{transform:rotate_deg,transition:rotate_transition}" />
          <!-- 指针图片 -->
          <img class="pointer" src="../../assets/draw2026/click1.png" @click="start(5)" />
        </div>
      </div>
      <div id="dial2" style="height:100%;width:100%;" v-show="isDrawVisible2">
        <div style="text-align:center;">
          <img src="../../assets/draw2026/title_bg2.png" style="width:80%;margin-top:5%;" />
        </div>
        <div style="margin-top:1%;text-align:center;">
          <van-tag type="danger" size="large" style="font-size:16px;width:80%;">
            您本阶段单量为 {{processNum}}，您还有 {{remaindrawChance}} 次抽奖机会
          </van-tag>
        </div>
        <!-- 转盘包裹2 -->
        <div class="rotate">
          <!-- 转盘图片 -->
          <img class="dish" src="../../assets/draw2026/dial3.png" :style="{transform:rotate_deg,transition:rotate_transition}" />
          <!-- 指针图片 -->
          <img class="pointer" src="../../assets/draw2026/click2.png" @click="start(6)" />
        </div>
      </div>
      <div id="dial3" style="height:100%;width:100%;" v-show="isDrawVisible3">
        <div style="text-align:center;">
          <img src="../../assets/draw2026/title_bg2.png" style="width:80%;margin-top:5%;" />
        </div>
        <div style="margin-top:1%;text-align:center;">
          <van-tag type="danger" size="large" style="font-size:16px;width:80%;">
            您本阶段单量为 {{processNum}}，您还有 {{remaindrawChance}} 次抽奖机会
          </van-tag>
        </div>
        <!-- 转盘包裹3 -->
        <div class="rotate">
          <!-- 转盘图片 -->
          <img class="dish" src="../../assets/draw2026/dial5.png" :style="{transform:rotate_deg,transition:rotate_transition}" />
          <!-- 指针图片 -->
          <img class="pointer" src="../../assets/draw2026/click2.png" @click="start(7)" />
        </div>
      </div>

      <div class="prize" v-show="prize>0">
        <div class="prize-box">
          <img class="prize-img" src="../../assets/draw2026/to_dial.png" alt="" @click="toHignDraw(drawedNum)">
        </div>
      </div>

      <div v-show="chance==5"><!--马上爆金豆-->
        <div class="tip" v-show="prize_name==2">
          <div class="tip-box">
            <img class="tip-img" src="../../assets/draw2026/18.8.png" alt="" @click="closeTip">
          </div>
        </div>
        <div class="tip" v-show="prize_name==3">
          <div class="tip-box">
            <img class="tip-img" src="../../assets/draw2026/28.8.png" alt="" @click="closeTip">
          </div>
        </div>
      </div>
      <div v-show="chance==6"><!--福袋爆红包 第三次抽奖-->
        <div class="tip" v-show="prize_name==1">
          <div class="tip-box">
            <img class="tip-img" src="../../assets/draw2026/188.png" alt="" @click="closeTip">
          </div>
        </div>
        <div class="tip" v-show="prize_name==2">
          <div class="tip-box">
            <img class="tip-img" src="../../assets/draw2026/288.png" alt="" @click="closeTip">
          </div>
        </div>
      </div>
      <div v-show="chance==7"><!--福袋爆红包 第五次抽奖-->
        <div class="tip" v-show="prize_name==1">
          <div class="tip-box">
            <img class="tip-img" src="../../assets/draw2026/488.png" alt="" @click="closeTip">
          </div>
        </div>
        <div class="tip" v-show="prize_name==2">
          <div class="tip-box">
            <img class="tip-img" src="../../assets/draw2026/588.png" alt="" @click="closeTip">
          </div>
        </div>
      </div>
      
    </div>
  </div>
  
</template>
<script>
import { Image, NavBar, NoticeBar, Swipe, SwipeItem, Tag, Toast } from "vant";
import { showToast } from 'vant'
import AppVue from "../../App.vue";
var light_timer; //灯光定时器
export default {
  name: "dial",
  data() {
    return {
      // LuckyClick: 3,
      circleList: [], //原点设置
      colorCircleFirst: "#FE4D32", //圆点颜色
      colorCircleSecond: "#fff", //圆点颜色
 
      cat: 45, //总共8个扇形区域，每个区域约45度
      isAllowClick: true, //是否能够点击
      rotate_deg: 0, //指针旋转的角度
      rotate_transition: "transform 3s ease-in-out", //初始化选中的过度属性控制
      remaindrawChance: 0,//剩余抽奖次数
      remainNum : 0,//差几单可抽奖
      drawedNum : 0,//已抽奖次数
      luckyerList: [],
      isDrawVisible1:true,
      isDrawVisible2:false,
      isDrawVisible3:false,
      prize: 0, //是否中奖
      prize_name: "", //奖品名字
      chance:0,
      processNum:0,//本阶段单量
    };
  },
  created() {
    this.showcircleList();
    this.GetData();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    //绘制圆点设置
    showcircleList() {
      let circleList = [];
      for (var i = 0; i < 16; i++) {
        circleList.push(i);
      }
      this.circleList = circleList;
      this.light();
    },
 
    //闪动效果
    light: function() {
      var that = this;
      clearInterval(light_timer);
      light_timer = setInterval(function() {
        if (that.colorCircleFirst == "#FE4D32") {
          that.colorCircleFirst = "#fff";
          that.colorCircleSecond = "#FE4D32";
        } else {
          that.colorCircleFirst = "#FE4D32";
          that.colorCircleSecond = "#fff";
        }
      }, 300); //设置圆点闪烁的效果
    },
    toHignDraw(drawnum){
      if(drawnum==2){
        this.isDrawVisible2=true;
        this.isDrawVisible1=false;
        this.isDrawVisible3=false;
        this.prize=0;
      }else if(drawnum==4){
        this.isDrawVisible3=true;
        this.isDrawVisible1=false;
        this.isDrawVisible2=false;
        this.prize=0;
      }
    },
    closeTip(){
      this.chance=0;
      this.prize_name="";
    },
 
    start(chance) {
      // if (this.remaindrawChance == 0) {
      //   alert("机会已经用完了");
      //   return;
      // }
      if(this.drawedNum==2&&this.isDrawVisible2==false){
        this.prize=this.drawedNum;
      }else if(this.drawedNum==4&&this.isDrawVisible3==false){
        this.prize=this.drawedNum;
      }else{
        if(chance==5){
          this.rotating(chance);
        }else if(chance==6){
          this.rotating2(chance);
        }else if(chance==7){
          this.rotating3(chance);
        }
        this.prize=0;
      }

    },
 
    rotating(chance) {
      if (!this.isAllowClick) return;
      this.isAllowClick = false;
      this.rotate_transition = "transform 3s ease-in-out";
      // this.remaindrawChance--;
      // var rand_circle = 5; //默认多旋转5圈

      this.$http
        .get("Activity2026/LuckyDraw20262_2?period=3", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") {
            this.remaindrawChance--;
            var rand_circle = 5; //默认多旋转5圈

            console.log(res.data.Data);
            var winningIndex = res.data.Data;
            console.log(winningIndex);
            var randomDeg = 360 - winningIndex*45+22.5; //当前下标对应的角度    45是总共8个扇形区域，每个区域约45度 （指针停留在奖品中间）
      
            var deg = rand_circle * 360 + randomDeg; //将要旋转的度数  由于是顺时针的转动方向需要用360度来减
            this.rotate_deg = "rotate(" + deg + "deg)";
      
            var that = this;
            setTimeout(function() {
              that.isAllowClick = true;
              that.rotate_deg = "rotate(" + 0 + "deg)"; //定时器关闭的时候重置角度
              that.rotate_transition = "";

              that.chance=chance;
              if (winningIndex == 1) {
                  that.prize_name = 1;
                  that.GetData();
                } else if (winningIndex == 2) {
                  that.prize_name = 2;
                  that.GetData();
                } else if (winningIndex == 3) {
                  // that.prize_name = 3;
                  // that.GetData();
                } else if (winningIndex == 4) {
                } else if (winningIndex == 5) {
                } else if (winningIndex == 6) {
                } else if (winningIndex == 7) {
                } else if (winningIndex == 8) {
                }
            }, 3500);
          } else {
            console.log(res.data);
            this.$toast(res.data);
          }
        });
        
    },
    rotating2(chance) {
      if (!this.isAllowClick) return;
      this.isAllowClick = false;
      this.rotate_transition = "transform 3s ease-in-out";
      // this.remaindrawChance--;
      // var rand_circle = 5; //默认多旋转5圈

      this.$http
        .get("Activity2026/LuckyDraw20262_2?period=3", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") {
            this.remaindrawChance--;
            var rand_circle = 5; //默认多旋转5圈

            console.log(res.data.Data);
            var winningIndex = res.data.Data;
            console.log(winningIndex);
            var randomDeg = 360 - winningIndex*45+22.5; //当前下标对应的角度    45是总共8个扇形区域，每个区域约45度 （指针停留在奖品中间）
      
            var deg = rand_circle * 360 + randomDeg; //将要旋转的度数  由于是顺时针的转动方向需要用360度来减
            this.rotate_deg = "rotate(" + deg + "deg)";
      
            var that = this;
            setTimeout(function() {
              that.isAllowClick = true;
              that.rotate_deg = "rotate(" + 0 + "deg)"; //定时器关闭的时候重置角度
              that.rotate_transition = "";

              that.chance=chance;
              if (winningIndex == 1) {
                  that.prize_name = 1;
                  that.GetData();
                  that.isDrawVisible1=true;
                  that.isDrawVisible2=false;
                  that.isDrawVisible3=false;
                } else if (winningIndex == 2) {
                  that.prize_name = 2;
                  that.GetData();
                  that.isDrawVisible1=true;
                  that.isDrawVisible2=false;
                  that.isDrawVisible3=false;
                } else if (winningIndex == 3) {
                } else if (winningIndex == 4) {
                } else if (winningIndex == 5) {
                } else if (winningIndex == 6) {
                } else if (winningIndex == 7) {
                } else if (winningIndex == 8) {
                }
            }, 3500);
          } else {
            console.log(res.data);
            this.$toast(res.data);
          }
        });
    },
    rotating3(chance) {
      if (!this.isAllowClick) return;
      this.isAllowClick = false;
      this.rotate_transition = "transform 3s ease-in-out";
      // this.remaindrawChance--;
      // var rand_circle = 5; //默认多旋转5圈

      this.$http
        .get("Activity2026/LuckyDraw20262_2?period=3", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") {
            this.remaindrawChance--;
            var rand_circle = 5; //默认多旋转5圈

            console.log(res.data.Data);
            var winningIndex = res.data.Data;
            console.log(winningIndex);
            var randomDeg = 360 - winningIndex*45+22.5; //当前下标对应的角度    45是总共8个扇形区域，每个区域约45度 （指针停留在奖品中间）
      
            var deg = rand_circle * 360 + randomDeg; //将要旋转的度数  由于是顺时针的转动方向需要用360度来减
            this.rotate_deg = "rotate(" + deg + "deg)";
      
            var that = this;
            setTimeout(function() {
              that.isAllowClick = true;
              that.rotate_deg = "rotate(" + 0 + "deg)"; //定时器关闭的时候重置角度
              that.rotate_transition = "";

              that.chance=chance;
              if (winningIndex == 1) {
                  that.prize_name = 1;
                  that.GetData();
                  that.isDrawVisible1=true;
                  that.isDrawVisible2=false;
                  that.isDrawVisible3=false;
                } else if (winningIndex == 2) {
                  that.prize_name = 2;
                  that.GetData();
                  that.isDrawVisible1=true;
                  that.isDrawVisible2=false;
                  that.isDrawVisible3=false;
                } else if (winningIndex == 3) {
                } else if (winningIndex == 4) {
                } else if (winningIndex == 5) {
                } else if (winningIndex == 6) {   
                } else if (winningIndex == 7) {  
                } else if (winningIndex == 8) {
                }
            }, 3500);
          } else {
            console.log(res.data);
            this.$toast(res.data);
          }
        });
    },
    toDrawLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "LuckDrawRecord2026",
        params: {},
      });
    },
    toDrawDetail() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "ActivityDetail",
        params: {},
      });
    },
    GetData() {
      var that = this;
      that.$http.get("Activity2026/Get2Luckyer2026?period=3").then((res) => {
        that.luckyerList = res.data.ListData;
      });
      that.$http.get("Activity2026/GetDrawChance2026?period=3").then((res) => {
        that.remaindrawChance = res.data.Data.RemainChance;
        that.remainNum = res.data.Data.RemainNum;
        that.drawedNum = res.data.Data.DrawedNum;
        that.processNum = res.data.Data.ProcessNum;
      });
      
    },
     onClickLeft() {
      this.$router.back(-1);
    },
 
    //设置概率
    set() {
      var winIndex;
      //方法2
      var __rand__ = Math.random();
      if (__rand__ < 0.3) winIndex = 2;
      else if (__rand__ < 0.6) winIndex = 1;
      else if (__rand__ < 0.99) winIndex = 4;
      else if (__rand__ < 0.92) winIndex = 3;
      else if (__rand__ == 0.99) winIndex = 0;
 
      return winIndex;
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
};
</script>
<style scoped>
.dial{
  height: 100%;
  width: 100%;
  position: relative;
  background-image: url('../../assets/draw2026/draw_bg.png');
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: contain;
}
.times {
  text-align: center;
  line-height: 1.8rem;
  background: #fff;
}
.rotate {
  /* width: 12.1rem;
  height: 12.1rem; */
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* position: absolute; */
  /* top: 55%; */
  left: 50%;
  transform: translate(-50%, -50%);


  max-width: 100%;
  height: 400px;
  margin-top: 45%; /* 例如，如果你想要一个16:9的宽高比 */
  position: relative;
}
 
.rotate .dish {
  width: 25rem;
  height: 25rem;
}
 
.pointer {
  width: 7.15rem;
  height: 8.65rem;
  position: absolute;
  top: 48%;
  left: 50.5%;
  transform: translate(-50%, -50%);
}
 
.prize {
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -ms-grid-row-align: center;
  align-items: center;
  z-index: 100;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}


/*新增css*/ 
.prize {
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -ms-grid-row-align: center;
  align-items: center;
  z-index: 100;
}
.prize-box {
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.prize-img {
  width: 100vw;
  max-height: 352px;
  max-width: 375px;
}


.tip {
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -ms-grid-row-align: center;
  align-items: center;
  z-index: 100;
}
.tip-box {
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tip-img {
  width: 100vw;
  max-height: 452px;
  max-width: 395px;
}

</style>